const turkeyLocations = {
  "Adana": {
    lat: 37.0,
    lng: 35.3213,
    districts: {
      "Seyhan": { lat: 36.9914, lng: 35.3308 },
      "Yüreğir": { lat: 37.0167, lng: 35.4167 },
      "Çukurova": { lat: 37.0333, lng: 35.3833 },
      "Sarıçam": { lat: 37.0667, lng: 35.4833 },
      "Karaisalı": { lat: 37.2500, lng: 35.0667 },
      "Ceyhan": { lat: 37.0286, lng: 35.8125 },
      "Kozan": { lat: 37.4536, lng: 35.8158 },
      "İmamoğlu": { lat: 37.2833, lng: 35.6667 },
      "Pozantı": { lat: 37.4333, lng: 34.8667 },
      "Aladağ": { lat: 37.5500, lng: 35.4000 },
      "Feke": { lat: 37.8167, lng: 35.9167 },
      "Saimbeyli": { lat: 37.9833, lng: 36.1000 },
      "Tufanbeyli": { lat: 38.2667, lng: 36.2167 },
      "Yumurtalık": { lat: 36.7667, lng: 35.7833 },
      "Karataş": { lat: 36.5667, lng: 35.3833 }
    }
  },
  "Adıyaman": {
    lat: 37.7648,
    lng: 38.2786,
    districts: {
      "Merkez": { lat: 37.7648, lng: 38.2786 },
      "Kahta": { lat: 37.7833, lng: 38.6167 },
      "Besni": { lat: 37.6833, lng: 37.8500 },
      "Gölbaşı": { lat: 37.7833, lng: 37.6333 },
      "Gerger": { lat: 37.9667, lng: 39.0333 },
      "Çelikhan": { lat: 38.0333, lng: 38.0333 },
      "Samsat": { lat: 37.5833, lng: 38.4667 },
      "Sincik": { lat: 38.0333, lng: 38.6167 },
      "Tut": { lat: 37.8000, lng: 37.9167 }
    }
  },
  "Afyonkarahisar": {
    lat: 38.7507,
    lng: 30.5567,
    districts: {
      "Merkez": { lat: 38.7507, lng: 30.5567 },
      "Sandıklı": { lat: 38.4667, lng: 30.2500 },
      "Dinar": { lat: 38.0667, lng: 30.1500 },
      "Bolvadin": { lat: 38.7167, lng: 31.0500 },
      "Emirdağ": { lat: 39.0167, lng: 31.1500 },
      "Çay": { lat: 38.5833, lng: 31.0333 },
      "Sultandağı": { lat: 38.5333, lng: 31.2333 },
      "Sinanpaşa": { lat: 38.7500, lng: 30.2333 },
      "İhsaniye": { lat: 38.9833, lng: 30.4167 },
      "Şuhut": { lat: 38.5333, lng: 30.5500 },
      "Dazkırı": { lat: 37.9667, lng: 29.9000 },
      "Başmakçı": { lat: 37.8833, lng: 29.9833 },
      "Bayat": { lat: 38.9667, lng: 31.3833 },
      "İscehisar": { lat: 38.8333, lng: 30.7500 },
      "Çobanlar": { lat: 38.7000, lng: 30.7667 },
      "Hocalar": { lat: 38.4000, lng: 30.0667 },
      "Evciler": { lat: 38.3167, lng: 30.0333 },
      "Kızılören": { lat: 38.8500, lng: 31.2500 }
    }
  },
  "Ağrı": {
    lat: 39.7191,
    lng: 43.0503,
    districts: {
      "Merkez": { lat: 39.7191, lng: 43.0503 },
      "Patnos": { lat: 39.2333, lng: 42.8667 },
      "Doğubayazıt": { lat: 39.5500, lng: 44.0833 },
      "Eleşkirt": { lat: 39.8000, lng: 42.6833 },
      "Diyadin": { lat: 39.5500, lng: 43.6667 },
      "Tutak": { lat: 39.5333, lng: 42.8000 },
      "Taşlıçay": { lat: 39.6333, lng: 43.2667 },
      "Hamur": { lat: 39.1500, lng: 42.9667 }
    }
  },
  "Amasya": {
    lat: 40.6499,
    lng: 35.8353,
    districts: {
      "Merkez": { lat: 40.6499, lng: 35.8353 },
      "Merzifon": { lat: 40.8667, lng: 35.4667 },
      "Suluova": { lat: 40.8333, lng: 35.6500 },
      "Taşova": { lat: 40.7500, lng: 36.3167 },
      "Gümüşhacıköy": { lat: 40.8667, lng: 35.2167 },
      "Göynücek": { lat: 40.3833, lng: 35.5167 },
      "Hamamözü": { lat: 40.6833, lng: 35.0333 }
    }
  },
  "Ankara": {
    lat: 39.9334,
    lng: 32.8597,
    districts: {
      "Çankaya": { lat: 39.9000, lng: 32.8600 },
      "Keçiören": { lat: 39.9833, lng: 32.8667 },
      "Yenimahalle": { lat: 39.9667, lng: 32.8000 },
      "Mamak": { lat: 39.9333, lng: 32.9333 },
      "Etimesgut": { lat: 39.9500, lng: 32.6667 },
      "Sincan": { lat: 39.9667, lng: 32.5833 },
      "Altındağ": { lat: 39.9500, lng: 32.8667 },
      "Pursaklar": { lat: 40.0333, lng: 32.9000 },
      "Gölbaşı": { lat: 39.7833, lng: 32.8000 },
      "Polatlı": { lat: 39.5833, lng: 32.1500 },
      "Beypazarı": { lat: 40.1667, lng: 31.9167 },
      "Çubuk": { lat: 40.2333, lng: 33.0333 },
      "Kahramankazan": { lat: 40.1167, lng: 32.6833 },
      "Akyurt": { lat: 40.1333, lng: 33.0833 },
      "Elmadağ": { lat: 39.9167, lng: 33.2333 },
      "Haymana": { lat: 39.4333, lng: 32.5000 },
      "Şereflikoçhisar": { lat: 38.9333, lng: 33.5333 },
      "Bala": { lat: 39.5500, lng: 33.1167 },
      "Kızılcahamam": { lat: 40.4667, lng: 32.6500 },
      "Nallıhan": { lat: 40.1833, lng: 31.3500 },
      "Ayaş": { lat: 40.0167, lng: 32.3333 },
      "Güdül": { lat: 40.2167, lng: 32.2500 },
      "Kalecik": { lat: 40.1000, lng: 33.4167 },
      "Evren": { lat: 39.0167, lng: 33.8000 },
      "Çamlıdere": { lat: 40.4833, lng: 32.4667 }
    }
  },
  "Antalya": {
    lat: 36.8969,
    lng: 30.7133,
    districts: {
      "Muratpaşa": { lat: 36.8841, lng: 30.7056 },
      "Kepez": { lat: 36.9500, lng: 30.7167 },
      "Konyaaltı": { lat: 36.8667, lng: 30.6167 },
      "Döşemealtı": { lat: 37.0167, lng: 30.6000 },
      "Aksu": { lat: 36.9333, lng: 30.8333 },
      "Alanya": { lat: 36.5500, lng: 32.0000 },
      "Manavgat": { lat: 36.7833, lng: 31.4333 },
      "Serik": { lat: 36.9167, lng: 31.1000 },
      "Kumluca": { lat: 36.3500, lng: 30.2833 },
      "Kaş": { lat: 36.2000, lng: 29.6500 },
      "Kemer": { lat: 36.5833, lng: 30.5500 },
      "Finike": { lat: 36.3000, lng: 30.1500 },
      "Gazipaşa": { lat: 36.2667, lng: 32.3167 },
      "Demre": { lat: 36.2500, lng: 29.9833 },
      "Elmalı": { lat: 36.7333, lng: 29.9167 },
      "Korkuteli": { lat: 37.0667, lng: 30.2000 },
      "Akseki": { lat: 37.0500, lng: 31.7833 },
      "İbradı": { lat: 37.1000, lng: 31.6000 },
      "Gündoğmuş": { lat: 36.8167, lng: 32.0167 }
    }
  },
  "Artvin": {
    lat: 41.1828,
    lng: 41.8183,
    districts: {
      "Merkez": { lat: 41.1828, lng: 41.8183 },
      "Hopa": { lat: 41.4167, lng: 41.4167 },
      "Borçka": { lat: 41.3500, lng: 41.6833 },
      "Arhavi": { lat: 41.3500, lng: 41.3000 },
      "Yusufeli": { lat: 40.8167, lng: 41.5333 },
      "Şavşat": { lat: 41.2333, lng: 42.3667 },
      "Ardanuç": { lat: 41.1333, lng: 42.0667 },
      "Murgul": { lat: 41.2500, lng: 41.6500 }
    }
  },
  "Aydın": {
    lat: 37.8560,
    lng: 27.8416,
    districts: {
      "Efeler": { lat: 37.8500, lng: 27.8500 },
      "Nazilli": { lat: 37.9167, lng: 28.3167 },
      "Söke": { lat: 37.7500, lng: 27.4167 },
      "Kuşadası": { lat: 37.8667, lng: 27.2667 },
      "Didim": { lat: 37.3833, lng: 27.2667 },
      "Çine": { lat: 37.6167, lng: 28.0667 },
      "İncirliova": { lat: 37.8500, lng: 27.7333 },
      "Germencik": { lat: 37.8667, lng: 27.6000 },
      "Bozdoğan": { lat: 37.6667, lng: 28.3000 },
      "Sultanhisar": { lat: 37.8833, lng: 28.1500 },
      "Koçarlı": { lat: 37.7667, lng: 27.6833 },
      "Yenipazar": { lat: 37.8167, lng: 28.1833 },
      "Buharkent": { lat: 37.9667, lng: 28.7500 },
      "Kuyucak": { lat: 37.9167, lng: 28.4667 },
      "Karacasu": { lat: 37.7333, lng: 28.6000 },
      "Köşk": { lat: 37.8500, lng: 28.0500 },
      "Karpuzlu": { lat: 37.5500, lng: 28.1167 }
    }
  },
  "Balıkesir": {
    lat: 39.6484,
    lng: 27.8826,
    districts: {
      "Altıeylül": { lat: 39.6500, lng: 27.8833 },
      "Karesi": { lat: 39.6500, lng: 27.8833 },
      "Bandırma": { lat: 40.3500, lng: 27.9667 },
      "Edremit": { lat: 39.5833, lng: 27.0167 },
      "Gönen": { lat: 40.1167, lng: 27.6500 },
      "Burhaniye": { lat: 39.5000, lng: 26.9667 },
      "Ayvalık": { lat: 39.3167, lng: 26.6833 },
      "Bigadiç": { lat: 39.3833, lng: 28.1333 },
      "Susurluk": { lat: 39.9167, lng: 28.1667 },
      "Dursunbey": { lat: 39.5833, lng: 28.6333 },
      "Erdek": { lat: 40.4000, lng: 27.7833 },
      "Manyas": { lat: 40.0500, lng: 28.0000 },
      "Sındırgı": { lat: 39.2333, lng: 28.1667 },
      "İvrindi": { lat: 39.5833, lng: 27.4833 },
      "Havran": { lat: 39.5500, lng: 27.1000 },
      "Savaştepe": { lat: 39.3833, lng: 27.6500 },
      "Kepsut": { lat: 39.6833, lng: 28.1333 },
      "Marmara": { lat: 40.6333, lng: 27.5833 },
      "Balya": { lat: 39.7500, lng: 27.5833 }
    }
  },
  "Bilecik": {
    lat: 40.0567,
    lng: 30.0665,
    districts: {
      "Merkez": { lat: 40.0567, lng: 30.0665 },
      "Bozüyük": { lat: 39.9000, lng: 30.0333 },
      "Söğüt": { lat: 40.0167, lng: 30.1833 },
      "Osmaneli": { lat: 40.3500, lng: 30.0000 },
      "Pazaryeri": { lat: 39.9833, lng: 29.9000 },
      "Gölpazarı": { lat: 40.2833, lng: 30.3167 },
      "İnhisar": { lat: 40.0333, lng: 30.3667 },
      "Yenipazar": { lat: 40.2167, lng: 30.5500 }
    }
  },
  "Bingöl": {
    lat: 38.8854,
    lng: 40.4966,
    districts: {
      "Merkez": { lat: 38.8854, lng: 40.4966 },
      "Genç": { lat: 38.7500, lng: 40.5500 },
      "Solhan": { lat: 38.9667, lng: 41.0500 },
      "Karlıova": { lat: 39.3000, lng: 41.0000 },
      "Adaklı": { lat: 39.2167, lng: 40.4833 },
      "Kiğı": { lat: 39.3167, lng: 40.3500 },
      "Yayladere": { lat: 39.1833, lng: 40.0833 },
      "Yedisu": { lat: 39.4333, lng: 40.5500 }
    }
  },
  "Bitlis": {
    lat: 38.4006,
    lng: 42.1095,
    districts: {
      "Merkez": { lat: 38.4006, lng: 42.1095 },
      "Tatvan": { lat: 38.5000, lng: 42.2833 },
      "Ahlat": { lat: 38.7500, lng: 42.4833 },
      "Adilcevaz": { lat: 38.8000, lng: 42.7333 },
      "Güroymak": { lat: 38.5833, lng: 42.0167 },
      "Hizan": { lat: 38.2167, lng: 42.4333 },
      "Mutki": { lat: 38.4167, lng: 41.9167 }
    }
  },
  "Bolu": {
    lat: 40.7360,
    lng: 31.6061,
    districts: {
      "Merkez": { lat: 40.7360, lng: 31.6061 },
      "Gerede": { lat: 40.8000, lng: 32.2000 },
      "Mudurnu": { lat: 40.4667, lng: 31.2167 },
      "Mengen": { lat: 40.9333, lng: 32.0833 },
      "Göynük": { lat: 40.4000, lng: 30.7833 },
      "Yeniçağa": { lat: 40.7667, lng: 32.0333 },
      "Dörtdivan": { lat: 40.6500, lng: 31.9333 },
      "Seben": { lat: 40.3833, lng: 31.5667 },
      "Kıbrıscık": { lat: 40.4167, lng: 31.8500 }
    }
  },
  "Burdur": {
    lat: 37.7203,
    lng: 30.2906,
    districts: {
      "Merkez": { lat: 37.7203, lng: 30.2906 },
      "Bucak": { lat: 37.4500, lng: 30.6000 },
      "Gölhisar": { lat: 37.1333, lng: 29.5167 },
      "Tefenni": { lat: 37.3167, lng: 29.7833 },
      "Yeşilova": { lat: 37.5000, lng: 29.7667 },
      "Ağlasun": { lat: 37.6500, lng: 30.5333 },
      "Çavdır": { lat: 37.1500, lng: 29.7000 },
      "Karamanlı": { lat: 37.3667, lng: 29.8333 },
      "Altınyayla": { lat: 37.0000, lng: 29.5500 },
      "Çeltikçi": { lat: 37.5333, lng: 30.4833 },
      "Kemer": { lat: 37.3833, lng: 30.0667 }
    }
  },
  "Bursa": {
    lat: 40.1826,
    lng: 29.0665,
    districts: {
      "Osmangazi": { lat: 40.1833, lng: 29.0667 },
      "Nilüfer": { lat: 40.2167, lng: 28.9500 },
      "Yıldırım": { lat: 40.2000, lng: 29.1333 },
      "İnegöl": { lat: 40.0833, lng: 29.5167 },
      "Gemlik": { lat: 40.4333, lng: 29.1500 },
      "Mudanya": { lat: 40.3667, lng: 28.8833 },
      "Mustafakemalpaşa": { lat: 39.9833, lng: 28.4167 },
      "Karacabey": { lat: 40.2167, lng: 28.3667 },
      "Orhangazi": { lat: 40.4833, lng: 29.3167 },
      "Kestel": { lat: 40.2000, lng: 29.2167 },
      "Gürsu": { lat: 40.2333, lng: 29.1833 },
      "İznik": { lat: 40.4333, lng: 29.7167 },
      "Yenişehir": { lat: 40.2667, lng: 29.6500 },
      "Keles": { lat: 39.9167, lng: 29.2333 },
      "Orhaneli": { lat: 39.9000, lng: 28.9833 },
      "Büyükorhan": { lat: 39.7500, lng: 28.8833 },
      "Harmancık": { lat: 39.6667, lng: 29.1333 }
    }
  },
  "Çanakkale": {
    lat: 40.1553,
    lng: 26.4142,
    districts: {
      "Merkez": { lat: 40.1553, lng: 26.4142 },
      "Biga": { lat: 40.2333, lng: 27.2500 },
      "Çan": { lat: 40.0333, lng: 27.0500 },
      "Gelibolu": { lat: 40.4167, lng: 26.6667 },
      "Ezine": { lat: 39.7833, lng: 26.3333 },
      "Bayramiç": { lat: 39.8167, lng: 26.6167 },
      "Ayvacık": { lat: 39.6000, lng: 26.4000 },
      "Lapseki": { lat: 40.3500, lng: 26.6833 },
      "Yenice": { lat: 40.0000, lng: 27.2667 },
      "Gökçeada": { lat: 40.1667, lng: 25.9000 },
      "Bozcaada": { lat: 39.8333, lng: 26.0667 },
      "Eceabat": { lat: 40.1833, lng: 26.3500 }
    }
  },
  "Çankırı": {
    lat: 40.6013,
    lng: 33.6134,
    districts: {
      "Merkez": { lat: 40.6013, lng: 33.6134 },
      "Çerkeş": { lat: 40.8167, lng: 32.8833 },
      "Ilgaz": { lat: 40.9167, lng: 33.6333 },
      "Şabanözü": { lat: 40.5000, lng: 33.4167 },
      "Kurşunlu": { lat: 40.8333, lng: 33.2500 },
      "Orta": { lat: 40.6333, lng: 33.1000 },
      "Yapraklı": { lat: 40.7500, lng: 33.7833 },
      "Atkaracalar": { lat: 40.8167, lng: 33.0667 },
      "Kızılırmak": { lat: 40.3333, lng: 33.7333 },
      "Bayramören": { lat: 40.9500, lng: 33.5000 },
      "Korgun": { lat: 40.7333, lng: 33.5167 },
      "Eldivan": { lat: 40.5333, lng: 33.5000 }
    }
  },
  "Çorum": {
    lat: 40.5489,
    lng: 34.9533,
    districts: {
      "Merkez": { lat: 40.5489, lng: 34.9533 },
      "Sungurlu": { lat: 40.1667, lng: 34.3833 },
      "Osmancık": { lat: 40.9667, lng: 34.8000 },
      "Alaca": { lat: 40.1667, lng: 34.8333 },
      "İskilip": { lat: 40.7333, lng: 34.4667 },
      "Kargı": { lat: 41.1333, lng: 34.4833 },
      "Mecitözü": { lat: 40.5167, lng: 34.8000 },
      "Bayat": { lat: 40.6500, lng: 34.3333 },
      "Ortaköy": { lat: 40.2667, lng: 35.2500 },
      "Dodurga": { lat: 40.8500, lng: 34.8167 },
      "Laçin": { lat: 40.7667, lng: 34.9000 },
      "Oğuzlar": { lat: 40.7167, lng: 34.7167 },
      "Boğazkale": { lat: 40.0167, lng: 34.6167 },
      "Uğurludağ": { lat: 40.0667, lng: 34.5333 }
    }
  },
  "Denizli": {
    lat: 37.7765,
    lng: 29.0864,
    districts: {
      "Pamukkale": { lat: 37.9167, lng: 29.1167 },
      "Merkezefendi": { lat: 37.7667, lng: 29.0833 },
      "Çivril": { lat: 38.3000, lng: 29.7333 },
      "Acıpayam": { lat: 37.4333, lng: 29.3500 },
      "Tavas": { lat: 37.5833, lng: 29.0667 },
      "Buldan": { lat: 38.0500, lng: 28.8333 },
      "Sarayköy": { lat: 37.9333, lng: 28.9167 },
      "Kale": { lat: 37.4500, lng: 28.8500 },
      "Honaz": { lat: 37.7500, lng: 29.2667 },
      "Çal": { lat: 38.0833, lng: 29.4000 },
      "Güney": { lat: 38.1500, lng: 29.0667 },
      "Çameli": { lat: 37.0667, lng: 29.3500 },
      "Bozkurt": { lat: 37.8000, lng: 29.6000 },
      "Serinhisar": { lat: 37.5833, lng: 29.2667 },
      "Bekilli": { lat: 38.2333, lng: 29.4167 },
      "Baklan": { lat: 38.0167, lng: 29.6167 },
      "Beyağaç": { lat: 37.2833, lng: 28.9833 },
      "Babadağ": { lat: 37.8167, lng: 28.8667 }
    }
  },
  "Diyarbakır": {
    lat: 37.9144,
    lng: 40.2306,
    districts: {
      "Bağlar": { lat: 37.9167, lng: 40.1833 },
      "Kayapınar": { lat: 37.9333, lng: 40.1500 },
      "Yenişehir": { lat: 37.9000, lng: 40.2333 },
      "Sur": { lat: 37.9167, lng: 40.2333 },
      "Bismil": { lat: 37.8500, lng: 40.6667 },
      "Ergani": { lat: 38.2667, lng: 39.7667 },
      "Çınar": { lat: 37.7167, lng: 40.4167 },
      "Silvan": { lat: 38.1333, lng: 41.0000 },
      "Kulp": { lat: 38.5000, lng: 41.0000 },
      "Lice": { lat: 38.4500, lng: 40.6500 },
      "Hani": { lat: 38.4167, lng: 40.3833 },
      "Dicle": { lat: 38.3667, lng: 40.0833 },
      "Eğil": { lat: 38.2500, lng: 40.0833 },
      "Hazro": { lat: 38.2500, lng: 40.8000 },
      "Kocaköy": { lat: 38.3000, lng: 40.5000 },
      "Çermik": { lat: 38.1333, lng: 39.4500 },
      "Çüngüş": { lat: 38.2167, lng: 39.2833 }
    }
  },
  "Edirne": {
    lat: 41.6818,
    lng: 26.5623,
    districts: {
      "Merkez": { lat: 41.6818, lng: 26.5623 },
      "Keşan": { lat: 40.8500, lng: 26.6333 },
      "Uzunköprü": { lat: 41.2667, lng: 26.6833 },
      "İpsala": { lat: 40.9167, lng: 26.3833 },
      "Havsa": { lat: 41.5500, lng: 26.8167 },
      "Enez": { lat: 40.7333, lng: 26.1000 },
      "Meriç": { lat: 41.1833, lng: 26.4167 },
      "Lalapaşa": { lat: 41.8333, lng: 26.7333 },
      "Süloğlu": { lat: 41.7667, lng: 26.9167 }
    }
  },
  "Elazığ": {
    lat: 38.6810,
    lng: 39.2264,
    districts: {
      "Merkez": { lat: 38.6810, lng: 39.2264 },
      "Kovancılar": { lat: 38.7167, lng: 39.8667 },
      "Karakoçan": { lat: 38.9500, lng: 40.0500 },
      "Palu": { lat: 38.7000, lng: 39.9333 },
      "Baskil": { lat: 38.5667, lng: 38.8333 },
      "Maden": { lat: 38.3833, lng: 39.6667 },
      "Sivrice": { lat: 38.4500, lng: 39.3167 },
      "Keban": { lat: 38.7833, lng: 38.7333 },
      "Ağın": { lat: 38.9333, lng: 38.7167 },
      "Arıcak": { lat: 38.5667, lng: 40.1333 },
      "Alacakaya": { lat: 38.2333, lng: 39.7667 }
    }
  },
  "Erzincan": {
    lat: 39.7500,
    lng: 39.5000,
    districts: {
      "Merkez": { lat: 39.7500, lng: 39.5000 },
      "Tercan": { lat: 39.7833, lng: 40.3833 },
      "Üzümlü": { lat: 39.7000, lng: 39.7000 },
      "Refahiye": { lat: 39.9000, lng: 38.7667 },
      "Çayırlı": { lat: 39.8000, lng: 40.0333 },
      "İliç": { lat: 39.4500, lng: 38.5667 },
      "Kemah": { lat: 39.6000, lng: 39.0333 },
      "Kemaliye": { lat: 39.2667, lng: 38.5000 },
      "Otlukbeli": { lat: 40.0167, lng: 39.0833 }
    }
  },
  "Erzurum": {
    lat: 39.9334,
    lng: 41.2700,
    districts: {
      "Yakutiye": { lat: 39.9167, lng: 41.2667 },
      "Palandöken": { lat: 39.8833, lng: 41.2667 },
      "Aziziye": { lat: 39.9500, lng: 41.0500 },
      "Horasan": { lat: 40.0333, lng: 42.1667 },
      "Oltu": { lat: 40.5500, lng: 41.9833 },
      "Pasinler": { lat: 39.9833, lng: 41.6833 },
      "Aşkale": { lat: 39.9167, lng: 40.6833 },
      "İspir": { lat: 40.4833, lng: 40.9833 },
      "Hınıs": { lat: 39.3667, lng: 41.7000 },
      "Tekman": { lat: 39.6333, lng: 41.5000 },
      "Karayazı": { lat: 39.7000, lng: 42.1667 },
      "Tortum": { lat: 40.3000, lng: 41.5500 },
      "Şenkaya": { lat: 40.5667, lng: 42.3500 },
      "Narman": { lat: 40.3333, lng: 41.8833 },
      "Köprüköy": { lat: 40.0167, lng: 41.8500 },
      "Olur": { lat: 40.8333, lng: 42.1333 },
      "Uzundere": { lat: 40.5333, lng: 41.5500 },
      "Çat": { lat: 39.6167, lng: 40.9833 },
      "Karaçoban": { lat: 39.3500, lng: 42.1000 },
      "Pazaryolu": { lat: 40.5333, lng: 41.0833 }
    }
  },
  "Eskişehir": {
    lat: 39.7767,
    lng: 30.5206,
    districts: {
      "Odunpazarı": { lat: 39.7667, lng: 30.5167 },
      "Tepebaşı": { lat: 39.7833, lng: 30.5000 },
      "Çifteler": { lat: 39.3833, lng: 31.0333 },
      "Sivrihisar": { lat: 39.4500, lng: 31.5333 },
      "Mahmudiye": { lat: 39.5000, lng: 30.9833 },
      "Seyitgazi": { lat: 39.4333, lng: 30.6833 },
      "Alpu": { lat: 39.7667, lng: 31.0333 },
      "İnönü": { lat: 39.8167, lng: 30.1500 },
      "Mihalıççık": { lat: 39.8500, lng: 31.5167 },
      "Sarıcakaya": { lat: 40.0333, lng: 30.6167 },
      "Han": { lat: 39.2667, lng: 30.8833 },
      "Günyüzü": { lat: 39.3333, lng: 31.7667 },
      "Beylikova": { lat: 39.6833, lng: 31.2333 },
      "Mihalgazi": { lat: 40.0167, lng: 31.0333 }
    }
  },
  "Gaziantep": {
    lat: 37.0662,
    lng: 37.3833,
    districts: {
      "Şahinbey": { lat: 37.0500, lng: 37.3667 },
      "Şehitkamil": { lat: 37.0833, lng: 37.3500 },
      "Nizip": { lat: 37.0167, lng: 37.7833 },
      "İslahiye": { lat: 37.0333, lng: 36.6333 },
      "Nurdağı": { lat: 37.1667, lng: 36.7333 },
      "Oğuzeli": { lat: 36.9667, lng: 37.5167 },
      "Araban": { lat: 37.4333, lng: 37.6833 },
      "Yavuzeli": { lat: 37.3167, lng: 37.5667 },
      "Karkamış": { lat: 36.8333, lng: 37.9833 }
    }
  },
  "Giresun": {
    lat: 40.9128,
    lng: 38.3895,
    districts: {
      "Merkez": { lat: 40.9128, lng: 38.3895 },
      "Bulancak": { lat: 40.9333, lng: 38.2333 },
      "Espiye": { lat: 40.9500, lng: 38.7167 },
      "Görele": { lat: 41.0333, lng: 39.0000 },
      "Tirebolu": { lat: 41.0000, lng: 38.8167 },
      "Keşap": { lat: 40.9167, lng: 38.5167 },
      "Piraziz": { lat: 40.9500, lng: 38.1333 },
      "Eynesil": { lat: 41.0667, lng: 39.1500 },
      "Dereli": { lat: 40.6167, lng: 38.3833 },
      "Yağlıdere": { lat: 40.7333, lng: 38.5000 },
      "Şebinkarahisar": { lat: 40.2833, lng: 38.4167 },
      "Alucra": { lat: 40.3333, lng: 38.7667 },
      "Çanakçı": { lat: 40.8500, lng: 38.5500 },
      "Güce": { lat: 40.8167, lng: 38.1667 },
      "Doğankent": { lat: 40.7667, lng: 38.7667 },
      "Çamoluk": { lat: 40.1333, lng: 38.6167 }
    }
  },
  "Gümüşhane": {
    lat: 40.4386,
    lng: 39.5086,
    districts: {
      "Merkez": { lat: 40.4386, lng: 39.5086 },
      "Kelkit": { lat: 40.1167, lng: 39.4333 },
      "Şiran": { lat: 40.1833, lng: 39.1167 },
      "Torul": { lat: 40.5500, lng: 39.2833 },
      "Kürtün": { lat: 40.6833, lng: 39.0833 },
      "Köse": { lat: 40.2167, lng: 39.6500 }
    }
  },
  "Hakkari": {
    lat: 37.5833,
    lng: 43.7333,
    districts: {
      "Merkez": { lat: 37.5833, lng: 43.7333 },
      "Yüksekova": { lat: 37.5667, lng: 44.2833 },
      "Şemdinli": { lat: 37.3000, lng: 44.5667 },
      "Çukurca": { lat: 37.2500, lng: 43.6167 }
    }
  },
  "Hatay": {
    lat: 36.4018,
    lng: 36.3498,
    districts: {
      "Antakya": { lat: 36.2000, lng: 36.1500 },
      "İskenderun": { lat: 36.5833, lng: 36.1667 },
      "Defne": { lat: 36.2333, lng: 36.1500 },
      "Arsuz": { lat: 36.4167, lng: 35.8833 },
      "Dörtyol": { lat: 36.8500, lng: 36.2167 },
      "Samandağ": { lat: 36.0833, lng: 35.9667 },
      "Kırıkhan": { lat: 36.5000, lng: 36.5000 },
      "Reyhanlı": { lat: 36.2667, lng: 36.5667 },
      "Erzin": { lat: 36.9500, lng: 36.2000 },
      "Altınözü": { lat: 36.1167, lng: 36.2500 },
      "Hassa": { lat: 36.8000, lng: 36.5167 },
      "Belen": { lat: 36.4833, lng: 36.2000 },
      "Yayladağı": { lat: 35.9000, lng: 36.0500 },
      "Kumlu": { lat: 36.3667, lng: 36.5167 },
      "Payas": { lat: 36.7667, lng: 36.2167 }
    }
  },
  "Isparta": {
    lat: 37.7648,
    lng: 30.5566,
    districts: {
      "Merkez": { lat: 37.7648, lng: 30.5566 },
      "Yalvaç": { lat: 38.2833, lng: 31.1833 },
      "Eğirdir": { lat: 37.8833, lng: 30.8500 },
      "Şarkikaraağaç": { lat: 38.0833, lng: 31.3667 },
      "Gelendost": { lat: 38.1167, lng: 30.9500 },
      "Senirkent": { lat: 38.1000, lng: 30.5500 },
      "Keçiborlu": { lat: 37.9500, lng: 30.3000 },
      "Uluborlu": { lat: 38.0667, lng: 30.4500 },
      "Sütçüler": { lat: 37.4833, lng: 31.0000 },
      "Atabey": { lat: 37.9333, lng: 30.6333 },
      "Gönen": { lat: 38.2500, lng: 30.5167 },
      "Aksu": { lat: 37.4333, lng: 30.8833 },
      "Yenişarbademli": { lat: 37.6500, lng: 31.3500 }
    }
  },
  "Mersin": {
    lat: 36.8121,
    lng: 34.6415,
    districts: {
      "Akdeniz": { lat: 36.7833, lng: 34.6167 },
      "Mezitli": { lat: 36.7667, lng: 34.4500 },
      "Toroslar": { lat: 36.8500, lng: 34.6333 },
      "Yenişehir": { lat: 36.8333, lng: 34.5833 },
      "Tarsus": { lat: 36.9167, lng: 34.9000 },
      "Silifke": { lat: 36.3833, lng: 33.9333 },
      "Erdemli": { lat: 36.6167, lng: 34.3167 },
      "Anamur": { lat: 36.0833, lng: 32.8333 },
      "Mut": { lat: 36.6333, lng: 33.4333 },
      "Gülnar": { lat: 36.3333, lng: 33.4000 },
      "Aydıncık": { lat: 36.1500, lng: 33.3167 },
      "Bozyazı": { lat: 36.1000, lng: 32.9667 },
      "Çamlıyayla": { lat: 37.1667, lng: 34.6000 }
    }
  },
  "İstanbul": {
    lat: 41.0082,
    lng: 28.9784,
    districts: {
      "Kadıköy": { lat: 40.9833, lng: 29.0333 },
      "Beşiktaş": { lat: 41.0500, lng: 29.0000 },
      "Üsküdar": { lat: 41.0167, lng: 29.0167 },
      "Beyoğlu": { lat: 41.0333, lng: 28.9833 },
      "Fatih": { lat: 41.0167, lng: 28.9500 },
      "Şişli": { lat: 41.0667, lng: 28.9833 },
      "Bakırköy": { lat: 40.9833, lng: 28.8667 },
      "Maltepe": { lat: 40.9333, lng: 29.1500 },
      "Ataşehir": { lat: 40.9833, lng: 29.1167 },
      "Pendik": { lat: 40.8833, lng: 29.2500 },
      "Kartal": { lat: 40.9000, lng: 29.1833 },
      "Ümraniye": { lat: 41.0167, lng: 29.1167 },
      "Beykoz": { lat: 41.1333, lng: 29.1000 },
      "Sarıyer": { lat: 41.1667, lng: 29.0500 },
      "Eyüpsultan": { lat: 41.0500, lng: 28.9333 },
      "Kağıthane": { lat: 41.0833, lng: 28.9667 },
      "Bahçelievler": { lat: 41.0000, lng: 28.8500 },
      "Bağcılar": { lat: 41.0333, lng: 28.8500 },
      "Küçükçekmece": { lat: 41.0000, lng: 28.7833 },
      "Büyükçekmece": { lat: 41.0167, lng: 28.5833 },
      "Başakşehir": { lat: 41.0833, lng: 28.8000 },
      "Esenyurt": { lat: 41.0333, lng: 28.6667 },
      "Beylikdüzü": { lat: 41.0000, lng: 28.6333 },
      "Avcılar": { lat: 40.9833, lng: 28.7167 },
      "Zeytinburnu": { lat: 40.9833, lng: 28.9000 },
      "Güngören": { lat: 41.0167, lng: 28.8667 },
      "Esenler": { lat: 41.0500, lng: 28.8667 },
      "Gaziosmanpaşa": { lat: 41.0667, lng: 28.9167 },
      "Sultangazi": { lat: 41.1000, lng: 28.8667 },
      "Bayrampaşa": { lat: 41.0500, lng: 28.9000 },
      "Sultanbeyli": { lat: 40.9667, lng: 29.2667 },
      "Tuzla": { lat: 40.8167, lng: 29.3000 },
      "Çekmeköy": { lat: 41.0333, lng: 29.1833 },
      "Sancaktepe": { lat: 41.0000, lng: 29.2333 },
      "Arnavutköy": { lat: 41.1833, lng: 28.7333 },
      "Silivri": { lat: 41.0833, lng: 28.2500 },
      "Çatalca": { lat: 41.1333, lng: 28.4667 },
      "Şile": { lat: 41.1833, lng: 29.6167 },
      "Adalar": { lat: 40.8667, lng: 29.0833 }
    }
  },
  "İzmir": {
    lat: 38.4237,
    lng: 27.1428,
    districts: {
      "Konak": { lat: 38.4167, lng: 27.1333 },
      "Karşıyaka": { lat: 38.4500, lng: 27.1167 },
      "Bornova": { lat: 38.4667, lng: 27.2167 },
      "Buca": { lat: 38.3833, lng: 27.1833 },
      "Bayraklı": { lat: 38.4667, lng: 27.1667 },
      "Çiğli": { lat: 38.5000, lng: 27.0500 },
      "Gaziemir": { lat: 38.3167, lng: 27.1333 },
      "Karabağlar": { lat: 38.3667, lng: 27.1167 },
      "Narlıdere": { lat: 38.3833, lng: 27.0000 },
      "Balçova": { lat: 38.3833, lng: 27.0500 },
      "Güzelbahçe": { lat: 38.3667, lng: 26.9000 },
      "Urla": { lat: 38.3167, lng: 26.7667 },
      "Çeşme": { lat: 38.3167, lng: 26.3000 },
      "Seferihisar": { lat: 38.2000, lng: 26.8333 },
      "Menderes": { lat: 38.2500, lng: 27.1333 },
      "Torbalı": { lat: 38.1667, lng: 27.3500 },
      "Kemalpaşa": { lat: 38.4333, lng: 27.4167 },
      "Ödemiş": { lat: 38.2333, lng: 27.9667 },
      "Tire": { lat: 38.0833, lng: 27.7333 },
      "Bergama": { lat: 39.1167, lng: 27.1833 },
      "Aliağa": { lat: 38.8000, lng: 26.9667 },
      "Menemen": { lat: 38.6000, lng: 27.0667 },
      "Foça": { lat: 38.6667, lng: 26.7500 },
      "Dikili": { lat: 39.0667, lng: 26.8833 },
      "Kınık": { lat: 39.0833, lng: 27.3833 },
      "Kiraz": { lat: 38.2333, lng: 28.2000 },
      "Beydağ": { lat: 38.0833, lng: 28.2167 },
      "Bayındır": { lat: 38.2167, lng: 27.6500 },
      "Selçuk": { lat: 37.9500, lng: 27.3667 },
      "Karaburun": { lat: 38.6333, lng: 26.5167 }
    }
  },
  "Kars": {
    lat: 40.6167,
    lng: 43.1000,
    districts: {
      "Merkez": { lat: 40.6167, lng: 43.1000 },
      "Sarıkamış": { lat: 40.3333, lng: 42.5833 },
      "Kağızman": { lat: 40.1667, lng: 43.1333 },
      "Selim": { lat: 40.4667, lng: 42.7833 },
      "Digor": { lat: 40.3833, lng: 43.4167 },
      "Arpaçay": { lat: 40.8500, lng: 43.3333 },
      "Akyaka": { lat: 40.7333, lng: 43.6333 },
      "Susuz": { lat: 40.7833, lng: 43.1333 }
    }
  },
  "Kastamonu": {
    lat: 41.3887,
    lng: 33.7827,
    districts: {
      "Merkez": { lat: 41.3887, lng: 33.7827 },
      "Tosya": { lat: 41.0167, lng: 34.0333 },
      "Taşköprü": { lat: 41.5167, lng: 34.2167 },
      "Cide": { lat: 41.8833, lng: 33.0000 },
      "İnebolu": { lat: 41.9833, lng: 33.7667 },
      "Araç": { lat: 41.2500, lng: 33.3167 },
      "Daday": { lat: 41.4833, lng: 33.4500 },
      "Devrekani": { lat: 41.6000, lng: 33.8333 },
      "Küre": { lat: 41.8000, lng: 33.7167 },
      "Abana": { lat: 41.9833, lng: 34.0167 },
      "Bozkurt": { lat: 41.9500, lng: 34.0167 },
      "Çatalzeytin": { lat: 41.9500, lng: 34.2000 },
      "İhsangazi": { lat: 41.1167, lng: 33.6000 },
      "Seydiler": { lat: 41.5833, lng: 33.4833 },
      "Azdavay": { lat: 41.6500, lng: 33.2833 },
      "Pınarbaşı": { lat: 41.6333, lng: 34.0500 },
      "Şenpazar": { lat: 41.8167, lng: 33.2167 },
      "Doğanyurt": { lat: 41.9833, lng: 33.5500 },
      "Hanönü": { lat: 41.5000, lng: 34.4667 },
      "Ağlı": { lat: 41.7333, lng: 34.0333 }
    }
  },
  "Kayseri": {
    lat: 38.7312,
    lng: 35.4787,
    districts: {
      "Melikgazi": { lat: 38.7333, lng: 35.5000 },
      "Kocasinan": { lat: 38.7500, lng: 35.4500 },
      "Talas": { lat: 38.6833, lng: 35.5500 },
      "Develi": { lat: 38.3833, lng: 35.4833 },
      "Yahyalı": { lat: 38.1000, lng: 35.3500 },
      "Bünyan": { lat: 38.8500, lng: 35.8667 },
      "Pınarbaşı": { lat: 38.7167, lng: 36.3833 },
      "Yeşilhisar": { lat: 38.3500, lng: 35.0833 },
      "Tomarza": { lat: 38.4500, lng: 35.8000 },
      "İncesu": { lat: 38.6333, lng: 35.1833 },
      "Sarıoğlan": { lat: 39.0667, lng: 35.9667 },
      "Felahiye": { lat: 39.0833, lng: 35.5500 },
      "Özvatan": { lat: 39.1167, lng: 35.7000 },
      "Akkışla": { lat: 39.0500, lng: 35.8333 },
      "Sarız": { lat: 38.4833, lng: 36.5000 },
      "Hacılar": { lat: 38.6667, lng: 35.4667 }
    }
  },
  "Kırklareli": {
    lat: 41.7333,
    lng: 27.2167,
    districts: {
      "Merkez": { lat: 41.7333, lng: 27.2167 },
      "Lüleburgaz": { lat: 41.4000, lng: 27.3500 },
      "Babaeski": { lat: 41.4333, lng: 27.0833 },
      "Vize": { lat: 41.5667, lng: 27.7667 },
      "Pınarhisar": { lat: 41.6333, lng: 27.5167 },
      "Demirköy": { lat: 41.8167, lng: 27.9167 },
      "Kofçaz": { lat: 41.9500, lng: 27.1833 },
      "Pehlivanköy": { lat: 41.3500, lng: 26.9167 }
    }
  },
  "Kırşehir": {
    lat: 39.1425,
    lng: 34.1709,
    districts: {
      "Merkez": { lat: 39.1425, lng: 34.1709 },
      "Kaman": { lat: 39.3667, lng: 33.7167 },
      "Mucur": { lat: 39.0667, lng: 34.3833 },
      "Çiçekdağı": { lat: 39.6000, lng: 34.4167 },
      "Akpınar": { lat: 39.4500, lng: 34.0500 },
      "Akçakent": { lat: 39.3833, lng: 33.9500 },
      "Boztepe": { lat: 39.2667, lng: 34.0167 }
    }
  },
  "Kocaeli": {
    lat: 40.8533,
    lng: 29.8815,
    districts: {
      "İzmit": { lat: 40.7667, lng: 29.9167 },
      "Gebze": { lat: 40.8000, lng: 29.4333 },
      "Darıca": { lat: 40.7667, lng: 29.3833 },
      "Körfez": { lat: 40.7833, lng: 29.7667 },
      "Gölcük": { lat: 40.7167, lng: 29.8333 },
      "Derince": { lat: 40.7500, lng: 29.8167 },
      "Dilovası": { lat: 40.7833, lng: 29.5333 },
      "Çayırova": { lat: 40.8333, lng: 29.3833 },
      "Başiskele": { lat: 40.7167, lng: 29.9167 },
      "Kartepe": { lat: 40.7500, lng: 30.0333 },
      "Kandıra": { lat: 41.0667, lng: 30.1500 },
      "Karamürsel": { lat: 40.6833, lng: 29.6167 }
    }
  },
  "Konya": {
    lat: 37.8667,
    lng: 32.4833,
    districts: {
      "Selçuklu": { lat: 37.9000, lng: 32.4500 },
      "Meram": { lat: 37.8333, lng: 32.4333 },
      "Karatay": { lat: 37.8833, lng: 32.5167 },
      "Ereğli": { lat: 37.5167, lng: 34.0500 },
      "Akşehir": { lat: 38.3500, lng: 31.4167 },
      "Seydişehir": { lat: 37.4167, lng: 31.8500 },
      "Beyşehir": { lat: 37.6667, lng: 31.7333 },
      "Cihanbeyli": { lat: 38.6500, lng: 32.9167 },
      "Çumra": { lat: 37.5667, lng: 32.7667 },
      "Ilgın": { lat: 38.2833, lng: 31.9167 },
      "Kulu": { lat: 39.0833, lng: 33.0667 },
      "Karapınar": { lat: 37.7167, lng: 33.5500 },
      "Bozkır": { lat: 37.1833, lng: 32.2500 },
      "Hadim": { lat: 36.9833, lng: 32.4667 },
      "Sarayönü": { lat: 38.2667, lng: 32.4000 },
      "Hüyük": { lat: 37.9500, lng: 31.6000 },
      "Doğanhisar": { lat: 38.1500, lng: 31.6667 },
      "Yunak": { lat: 38.8167, lng: 31.7167 },
      "Tuzlukçu": { lat: 38.4667, lng: 31.2167 },
      "Altınekin": { lat: 38.3167, lng: 32.8667 },
      "Derbent": { lat: 37.4000, lng: 32.0167 },
      "Derebucak": { lat: 37.3833, lng: 31.5167 },
      "Emirgazi": { lat: 37.9000, lng: 33.8333 },
      "Güneysınır": { lat: 37.1000, lng: 32.7333 },
      "Halkapınar": { lat: 37.4500, lng: 34.1833 },
      "Taşkent": { lat: 36.9333, lng: 32.4833 },
      "Yalıhüyük": { lat: 37.3000, lng: 32.0833 },
      "Ahırlı": { lat: 37.1333, lng: 31.9833 },
      "Çeltik": { lat: 38.9500, lng: 31.8000 },
      "Kadınhanı": { lat: 38.2333, lng: 32.2167 }
    }
  },
  "Kütahya": {
    lat: 39.4167,
    lng: 29.9833,
    districts: {
      "Merkez": { lat: 39.4167, lng: 29.9833 },
      "Tavşanlı": { lat: 39.5500, lng: 29.4833 },
      "Simav": { lat: 39.0833, lng: 28.9833 },
      "Gediz": { lat: 39.0500, lng: 29.4167 },
      "Emet": { lat: 39.3333, lng: 29.2667 },
      "Domaniç": { lat: 39.8000, lng: 29.6000 },
      "Altıntaş": { lat: 39.0667, lng: 30.1167 },
      "Aslanapa": { lat: 39.2333, lng: 29.8833 },
      "Dumlupınar": { lat: 39.1167, lng: 29.9500 },
      "Hisarcık": { lat: 39.2500, lng: 29.2333 },
      "Pazarlar": { lat: 39.0667, lng: 29.1000 },
      "Şaphane": { lat: 39.0333, lng: 29.2333 },
      "Çavdarhisar": { lat: 39.2167, lng: 29.6167 }
    }
  },
  "Malatya": {
    lat: 38.3552,
    lng: 38.3095,
    districts: {
      "Battalgazi": { lat: 38.4000, lng: 38.4500 },
      "Yeşilyurt": { lat: 38.3167, lng: 38.2333 },
      "Doğanşehir": { lat: 38.0833, lng: 37.8833 },
      "Akçadağ": { lat: 38.3333, lng: 37.9667 },
      "Darende": { lat: 38.5500, lng: 37.5000 },
      "Hekimhan": { lat: 38.8167, lng: 37.9333 },
      "Yazıhan": { lat: 38.5833, lng: 38.2167 },
      "Arguvan": { lat: 38.7833, lng: 38.2667 },
      "Arapgir": { lat: 39.0500, lng: 38.4833 },
      "Pütürge": { lat: 38.2000, lng: 38.8667 },
      "Kuluncak": { lat: 38.9333, lng: 37.6333 },
      "Kale": { lat: 38.4500, lng: 38.7167 },
      "Doğanyol": { lat: 38.3333, lng: 38.8833 }
    }
  },
  "Manisa": {
    lat: 38.6191,
    lng: 27.4289,
    districts: {
      "Şehzadeler": { lat: 38.6167, lng: 27.4167 },
      "Yunusemre": { lat: 38.6000, lng: 27.3833 },
      "Akhisar": { lat: 38.9167, lng: 27.8333 },
      "Turgutlu": { lat: 38.5000, lng: 27.7000 },
      "Salihli": { lat: 38.4833, lng: 28.1333 },
      "Soma": { lat: 39.1833, lng: 27.6167 },
      "Alaşehir": { lat: 38.3500, lng: 28.5167 },
      "Saruhanlı": { lat: 38.7333, lng: 27.5667 },
      "Kırkağaç": { lat: 39.1000, lng: 27.6667 },
      "Demirci": { lat: 39.0500, lng: 28.6500 },
      "Gördes": { lat: 38.9333, lng: 28.3000 },
      "Sarıgöl": { lat: 38.2333, lng: 28.6833 },
      "Kula": { lat: 38.5500, lng: 28.6500 },
      "Selendi": { lat: 38.7500, lng: 28.8667 },
      "Gölmarmara": { lat: 38.7167, lng: 27.9167 },
      "Ahmetli": { lat: 38.5167, lng: 27.9333 },
      "Köprübaşı": { lat: 38.7667, lng: 28.4167 }
    }
  },
  "Kahramanmaraş": {
    lat: 37.5858,
    lng: 36.9371,
    districts: {
      "Dulkadiroğlu": { lat: 37.5833, lng: 36.9333 },
      "Onikişubat": { lat: 37.6000, lng: 36.9500 },
      "Elbistan": { lat: 38.2000, lng: 37.2000 },
      "Afşin": { lat: 38.2500, lng: 36.9167 },
      "Göksun": { lat: 38.0167, lng: 36.5000 },
      "Pazarcık": { lat: 37.4833, lng: 37.2833 },
      "Türkoğlu": { lat: 37.3833, lng: 36.8500 },
      "Andırın": { lat: 37.5667, lng: 36.3500 },
      "Çağlayancerit": { lat: 37.7500, lng: 37.3167 },
      "Nurhak": { lat: 37.9667, lng: 37.4500 },
      "Ekinözü": { lat: 38.0667, lng: 37.1833 }
    }
  },
  "Mardin": {
    lat: 37.3212,
    lng: 40.7245,
    districts: {
      "Artuklu": { lat: 37.3167, lng: 40.7333 },
      "Kızıltepe": { lat: 37.1833, lng: 40.5833 },
      "Nusaybin": { lat: 37.0667, lng: 41.2167 },
      "Midyat": { lat: 37.4167, lng: 41.3333 },
      "Derik": { lat: 37.3667, lng: 40.2667 },
      "Mazıdağı": { lat: 37.4833, lng: 40.4833 },
      "Ömerli": { lat: 37.4000, lng: 40.9500 },
      "Savur": { lat: 37.5333, lng: 40.8833 },
      "Dargeçit": { lat: 37.5500, lng: 41.7167 },
      "Yeşilli": { lat: 37.3333, lng: 40.8333 }
    }
  },
  "Muğla": {
    lat: 37.2153,
    lng: 28.3636,
    districts: {
      "Menteşe": { lat: 37.2167, lng: 28.3667 },
      "Bodrum": { lat: 37.0333, lng: 27.4333 },
      "Fethiye": { lat: 36.6500, lng: 29.1167 },
      "Marmaris": { lat: 36.8500, lng: 28.2667 },
      "Milas": { lat: 37.3167, lng: 27.7833 },
      "Dalaman": { lat: 36.7667, lng: 28.8000 },
      "Ortaca": { lat: 36.8333, lng: 28.7667 },
      "Datça": { lat: 36.7333, lng: 27.6833 },
      "Köyceğiz": { lat: 36.9667, lng: 28.6833 },
      "Yatağan": { lat: 37.3333, lng: 28.1333 },
      "Ula": { lat: 37.1000, lng: 28.4167 },
      "Kavaklıdere": { lat: 37.4333, lng: 28.3833 },
      "Seydikemer": { lat: 36.6167, lng: 29.3500 }
    }
  },
  "Muş": {
    lat: 38.9462,
    lng: 41.7539,
    districts: {
      "Merkez": { lat: 38.9462, lng: 41.7539 },
      "Bulanık": { lat: 39.1000, lng: 42.2833 },
      "Malazgirt": { lat: 39.1500, lng: 42.5333 },
      "Varto": { lat: 39.1667, lng: 41.4500 },
      "Hasköy": { lat: 38.6833, lng: 41.6667 },
      "Korkut": { lat: 38.7333, lng: 41.8333 }
    }
  },
  "Nevşehir": {
    lat: 38.6939,
    lng: 34.6857,
    districts: {
      "Merkez": { lat: 38.6939, lng: 34.6857 },
      "Ürgüp": { lat: 38.6333, lng: 34.9167 },
      "Avanos": { lat: 38.7167, lng: 34.8500 },
      "Gülşehir": { lat: 38.7500, lng: 34.6167 },
      "Hacıbektaş": { lat: 38.9333, lng: 34.5667 },
      "Kozaklı": { lat: 39.0000, lng: 34.8500 },
      "Derinkuyu": { lat: 38.3833, lng: 34.7333 },
      "Acıgöl": { lat: 38.5500, lng: 34.5167 }
    }
  },
  "Niğde": {
    lat: 37.9667,
    lng: 34.6833,
    districts: {
      "Merkez": { lat: 37.9667, lng: 34.6833 },
      "Bor": { lat: 37.9000, lng: 34.5500 },
      "Çiftlik": { lat: 38.1833, lng: 34.5333 },
      "Ulukışla": { lat: 37.5500, lng: 34.5000 },
      "Altunhisar": { lat: 38.0333, lng: 34.3667 },
      "Çamardı": { lat: 37.8167, lng: 34.9833 }
    }
  },
  "Ordu": {
    lat: 40.9839,
    lng: 37.8764,
    districts: {
      "Altınordu": { lat: 40.9833, lng: 37.8833 },
      "Ünye": { lat: 41.1333, lng: 37.2833 },
      "Fatsa": { lat: 41.0333, lng: 37.4833 },
      "Perşembe": { lat: 41.0667, lng: 37.7500 },
      "Ulubey": { lat: 40.8833, lng: 37.7500 },
      "Korgan": { lat: 40.8333, lng: 37.3500 },
      "Kumru": { lat: 40.8833, lng: 37.2500 },
      "Mesudiye": { lat: 40.4500, lng: 37.7833 },
      "Gölköy": { lat: 40.6833, lng: 37.6167 },
      "Gülyalı": { lat: 41.0500, lng: 37.9333 },
      "Kabadüz": { lat: 40.8667, lng: 37.9833 },
      "Akkuş": { lat: 40.8000, lng: 37.0167 },
      "Aybastı": { lat: 40.6833, lng: 37.4000 },
      "Çamaş": { lat: 40.9000, lng: 37.5333 },
      "Çatalpınar": { lat: 40.9333, lng: 37.4833 },
      "Gürgentepe": { lat: 40.7833, lng: 37.5833 },
      "İkizce": { lat: 41.0500, lng: 37.0833 },
      "Kabataş": { lat: 40.9000, lng: 37.3167 },
      "Çaybaşı": { lat: 41.0167, lng: 37.1500 }
    }
  },
  "Rize": {
    lat: 41.0201,
    lng: 40.5234,
    districts: {
      "Merkez": { lat: 41.0201, lng: 40.5234 },
      "Ardeşen": { lat: 41.1833, lng: 40.9833 },
      "Çayeli": { lat: 41.0833, lng: 40.7333 },
      "Pazar": { lat: 41.1833, lng: 40.8833 },
      "Fındıklı": { lat: 41.2500, lng: 41.1333 },
      "Güneysu": { lat: 40.9500, lng: 40.5500 },
      "İkizdere": { lat: 40.7500, lng: 40.5500 },
      "Kalkandere": { lat: 40.9167, lng: 40.4167 },
      "Çamlıhemşin": { lat: 41.0000, lng: 41.0167 },
      "Hemşin": { lat: 41.0167, lng: 40.9000 },
      "İyidere": { lat: 41.0000, lng: 40.3667 },
      "Derepazarı": { lat: 41.0167, lng: 40.4000 }
    }
  },
  "Sakarya": {
    lat: 40.7569,
    lng: 30.3781,
    districts: {
      "Adapazarı": { lat: 40.7833, lng: 30.4000 },
      "Serdivan": { lat: 40.7333, lng: 30.3500 },
      "Erenler": { lat: 40.7667, lng: 30.3833 },
      "Arifiye": { lat: 40.7167, lng: 30.3667 },
      "Hendek": { lat: 40.8000, lng: 30.7500 },
      "Sapanca": { lat: 40.6833, lng: 30.2667 },
      "Karasu": { lat: 41.1167, lng: 30.6833 },
      "Akyazı": { lat: 40.6833, lng: 30.6167 },
      "Geyve": { lat: 40.5167, lng: 30.3000 },
      "Pamukova": { lat: 40.5000, lng: 30.1667 },
      "Kaynarca": { lat: 41.1500, lng: 30.2833 },
      "Ferizli": { lat: 40.9500, lng: 30.4833 },
      "Kocaali": { lat: 41.0500, lng: 30.8500 },
      "Söğütlü": { lat: 40.9000, lng: 30.4833 },
      "Taraklı": { lat: 40.4000, lng: 30.4833 },
      "Karapürçek": { lat: 40.6333, lng: 30.5333 }
    }
  },
  "Samsun": {
    lat: 41.2928,
    lng: 36.3313,
    districts: {
      "Atakum": { lat: 41.3333, lng: 36.2333 },
      "İlkadım": { lat: 41.2833, lng: 36.3333 },
      "Canik": { lat: 41.2667, lng: 36.3833 },
      "Tekkeköy": { lat: 41.2000, lng: 36.4667 },
      "Bafra": { lat: 41.5667, lng: 35.9000 },
      "Çarşamba": { lat: 41.2000, lng: 36.7333 },
      "Terme": { lat: 41.2167, lng: 36.9667 },
      "Vezirköprü": { lat: 41.1333, lng: 35.4667 },
      "Havza": { lat: 40.9667, lng: 35.6833 },
      "Ladik": { lat: 40.9333, lng: 35.9000 },
      "Kavak": { lat: 41.0667, lng: 36.0333 },
      "Alaçam": { lat: 41.6000, lng: 35.6000 },
      "Salıpazarı": { lat: 41.0833, lng: 36.8333 },
      "19 Mayıs": { lat: 41.4833, lng: 35.9667 },
      "Asarcık": { lat: 41.0333, lng: 36.2000 },
      "Ayvacık": { lat: 41.0833, lng: 36.6833 },
      "Yakakent": { lat: 41.6333, lng: 35.5000 }
    }
  },
  "Siirt": {
    lat: 37.9333,
    lng: 41.9500,
    districts: {
      "Merkez": { lat: 37.9333, lng: 41.9500 },
      "Kurtalan": { lat: 37.9333, lng: 41.7000 },
      "Pervari": { lat: 37.9167, lng: 42.5333 },
      "Baykan": { lat: 38.1667, lng: 41.7833 },
      "Eruh": { lat: 37.7500, lng: 42.1667 },
      "Şirvan": { lat: 38.0500, lng: 42.0333 },
      "Tillo": { lat: 37.9333, lng: 41.9000 }
    }
  },
  "Sinop": {
    lat: 42.0231,
    lng: 35.1531,
    districts: {
      "Merkez": { lat: 42.0231, lng: 35.1531 },
      "Boyabat": { lat: 41.4667, lng: 34.7667 },
      "Gerze": { lat: 41.8000, lng: 35.1833 },
      "Durağan": { lat: 41.4333, lng: 35.0500 },
      "Ayancık": { lat: 41.9500, lng: 34.5833 },
      "Türkeli": { lat: 42.1167, lng: 34.3500 },
      "Erfelek": { lat: 41.8833, lng: 34.9333 },
      "Dikmen": { lat: 41.6167, lng: 35.0833 },
      "Saraydüzü": { lat: 41.3167, lng: 35.1500 }
    }
  },
  "Sivas": {
    lat: 39.7477,
    lng: 37.0179,
    districts: {
      "Merkez": { lat: 39.7477, lng: 37.0179 },
      "Şarkışla": { lat: 39.3500, lng: 36.4000 },
      "Gemerek": { lat: 39.1833, lng: 36.0667 },
      "Suşehri": { lat: 40.1667, lng: 38.0833 },
      "Yıldızeli": { lat: 39.8667, lng: 36.6000 },
      "Zara": { lat: 39.9000, lng: 37.7500 },
      "Kangal": { lat: 39.2333, lng: 37.3833 },
      "Divriği": { lat: 39.3667, lng: 38.1167 },
      "Gürün": { lat: 38.7167, lng: 37.2667 },
      "Hafik": { lat: 39.8500, lng: 37.3833 },
      "İmranlı": { lat: 39.8833, lng: 38.1000 },
      "Koyulhisar": { lat: 40.3000, lng: 37.8333 },
      "Akıncılar": { lat: 40.0167, lng: 38.3500 },
      "Altınyayla": { lat: 39.1833, lng: 36.8000 },
      "Doğanşar": { lat: 40.2500, lng: 37.5000 },
      "Gölova": { lat: 40.0500, lng: 37.9833 },
      "Ulaş": { lat: 39.5000, lng: 37.0333 }
    }
  },
  "Tekirdağ": {
    lat: 40.9833,
    lng: 27.5167,
    districts: {
      "Süleymanpaşa": { lat: 40.9833, lng: 27.5167 },
      "Çorlu": { lat: 41.1500, lng: 27.8000 },
      "Çerkezköy": { lat: 41.2833, lng: 27.9833 },
      "Kapaklı": { lat: 41.3333, lng: 27.9833 },
      "Ergene": { lat: 41.2833, lng: 27.7833 },
      "Malkara": { lat: 40.8833, lng: 26.9000 },
      "Hayrabolu": { lat: 41.2167, lng: 27.1000 },
      "Muratlı": { lat: 41.1667, lng: 27.5000 },
      "Saray": { lat: 41.4500, lng: 27.9167 },
      "Şarköy": { lat: 40.6167, lng: 27.1167 },
      "Marmaraereğlisi": { lat: 41.0333, lng: 27.9500 }
    }
  },
  "Tokat": {
    lat: 40.3167,
    lng: 36.5500,
    districts: {
      "Merkez": { lat: 40.3167, lng: 36.5500 },
      "Erbaa": { lat: 40.6667, lng: 36.5667 },
      "Turhal": { lat: 40.3833, lng: 36.0833 },
      "Niksar": { lat: 40.5833, lng: 36.9500 },
      "Zile": { lat: 40.3000, lng: 35.8833 },
      "Almus": { lat: 40.3667, lng: 36.9000 },
      "Reşadiye": { lat: 40.3833, lng: 37.3333 },
      "Artova": { lat: 40.1167, lng: 36.3333 },
      "Pazar": { lat: 40.2667, lng: 36.2833 },
      "Yeşilyurt": { lat: 40.3333, lng: 36.2167 },
      "Başçiftlik": { lat: 40.5500, lng: 36.4333 },
      "Sulusaray": { lat: 39.9833, lng: 36.4333 }
    }
  },
  "Trabzon": {
    lat: 41.0015,
    lng: 39.7178,
    districts: {
      "Ortahisar": { lat: 41.0000, lng: 39.7167 },
      "Akçaabat": { lat: 41.0167, lng: 39.5500 },
      "Yomra": { lat: 40.9500, lng: 39.8500 },
      "Arsin": { lat: 40.9167, lng: 40.0333 },
      "Of": { lat: 40.9500, lng: 40.2667 },
      "Araklı": { lat: 40.9333, lng: 40.0833 },
      "Sürmene": { lat: 40.9167, lng: 40.1167 },
      "Beşikdüzü": { lat: 41.0500, lng: 39.2333 },
      "Vakfıkebir": { lat: 41.0500, lng: 39.2833 },
      "Çarşıbaşı": { lat: 41.0500, lng: 39.4000 },
      "Maçka": { lat: 40.8167, lng: 39.6167 },
      "Tonya": { lat: 40.8833, lng: 39.2833 },
      "Şalpazarı": { lat: 40.9333, lng: 39.1833 },
      "Çaykara": { lat: 40.7500, lng: 40.2333 },
      "Dernekpazarı": { lat: 40.8000, lng: 40.2667 },
      "Düzköy": { lat: 40.8833, lng: 39.4167 },
      "Hayrat": { lat: 40.8667, lng: 40.3667 },
      "Köprübaşı": { lat: 40.7667, lng: 40.1167 }
    }
  },
  "Tunceli": {
    lat: 39.1079,
    lng: 39.5401,
    districts: {
      "Merkez": { lat: 39.1079, lng: 39.5401 },
      "Pertek": { lat: 38.8667, lng: 39.3167 },
      "Çemişgezek": { lat: 39.0500, lng: 38.9000 },
      "Hozat": { lat: 39.1000, lng: 39.2000 },
      "Ovacık": { lat: 39.3500, lng: 39.3167 },
      "Nazımiye": { lat: 39.1667, lng: 39.7833 },
      "Pülümür": { lat: 39.4833, lng: 39.9000 },
      "Mazgirt": { lat: 39.0167, lng: 39.6000 }
    }
  },
  "Şanlıurfa": {
    lat: 37.1591,
    lng: 38.7969,
    districts: {
      "Eyyübiye": { lat: 37.1500, lng: 38.7833 },
      "Haliliye": { lat: 37.1667, lng: 38.8000 },
      "Karaköprü": { lat: 37.2000, lng: 38.7667 },
      "Siverek": { lat: 37.7500, lng: 39.3167 },
      "Viranşehir": { lat: 37.2333, lng: 39.7667 },
      "Suruç": { lat: 36.9833, lng: 38.4333 },
      "Akçakale": { lat: 36.7167, lng: 38.9500 },
      "Birecik": { lat: 37.0333, lng: 37.9833 },
      "Bozova": { lat: 37.3667, lng: 38.5167 },
      "Ceylanpınar": { lat: 36.8500, lng: 40.0500 },
      "Harran": { lat: 36.8500, lng: 39.0333 },
      "Hilvan": { lat: 37.5833, lng: 38.9500 },
      "Halfeti": { lat: 37.2333, lng: 37.8667 }
    }
  },
  "Uşak": {
    lat: 38.6823,
    lng: 29.4082,
    districts: {
      "Merkez": { lat: 38.6823, lng: 29.4082 },
      "Banaz": { lat: 38.7333, lng: 29.7500 },
      "Eşme": { lat: 38.4000, lng: 29.0500 },
      "Sivaslı": { lat: 38.5000, lng: 29.6833 },
      "Ulubey": { lat: 38.4333, lng: 29.3000 },
      "Karahallı": { lat: 38.3000, lng: 29.5167 }
    }
  },
  "Van": {
    lat: 38.4891,
    lng: 43.4089,
    districts: {
      "İpekyolu": { lat: 38.5000, lng: 43.4000 },
      "Tuşba": { lat: 38.5500, lng: 43.4333 },
      "Edremit": { lat: 38.4333, lng: 43.3000 },
      "Erciş": { lat: 39.0333, lng: 43.3333 },
      "Özalp": { lat: 38.6500, lng: 43.9833 },
      "Çaldıran": { lat: 39.1333, lng: 43.9000 },
      "Başkale": { lat: 38.0500, lng: 44.0167 },
      "Muradiye": { lat: 39.0333, lng: 43.7667 },
      "Gevaş": { lat: 38.3000, lng: 43.1000 },
      "Gürpınar": { lat: 38.3333, lng: 43.4167 },
      "Saray": { lat: 38.7000, lng: 44.2167 },
      "Çatak": { lat: 38.0167, lng: 43.0500 },
      "Bahçesaray": { lat: 38.1333, lng: 42.8000 }
    }
  },
  "Yozgat": {
    lat: 39.8181,
    lng: 34.8147,
    districts: {
      "Merkez": { lat: 39.8181, lng: 34.8147 },
      "Sorgun": { lat: 39.8167, lng: 35.1833 },
      "Yerköy": { lat: 39.6333, lng: 34.4667 },
      "Akdağmadeni": { lat: 39.6667, lng: 35.8833 },
      "Boğazlıyan": { lat: 39.2000, lng: 35.2500 },
      "Çayıralan": { lat: 39.3167, lng: 35.6500 },
      "Şefaatli": { lat: 39.5000, lng: 34.8500 },
      "Sarıkaya": { lat: 39.4833, lng: 35.4167 },
      "Çekerek": { lat: 40.0667, lng: 35.5000 },
      "Kadışehri": { lat: 39.9667, lng: 35.9333 },
      "Saraykent": { lat: 39.4500, lng: 35.1167 },
      "Aydıncık": { lat: 39.3833, lng: 35.6333 },
      "Yenifakılı": { lat: 38.9833, lng: 35.0333 },
      "Çandır": { lat: 40.0833, lng: 35.1333 }
    }
  },
  "Zonguldak": {
    lat: 41.4564,
    lng: 31.7987,
    districts: {
      "Merkez": { lat: 41.4564, lng: 31.7987 },
      "Ereğli": { lat: 41.2833, lng: 31.4167 },
      "Çaycuma": { lat: 41.4333, lng: 32.0833 },
      "Devrek": { lat: 41.2167, lng: 32.1500 },
      "Alaplı": { lat: 41.1833, lng: 31.3833 },
      "Gökçebey": { lat: 41.3167, lng: 32.1500 },
      "Kilimli": { lat: 41.5000, lng: 31.8333 },
      "Kozlu": { lat: 41.4333, lng: 31.7500 }
    }
  },
  "Aksaray": {
    lat: 38.3687,
    lng: 34.0370,
    districts: {
      "Merkez": { lat: 38.3687, lng: 34.0370 },
      "Ortaköy": { lat: 38.7333, lng: 34.0333 },
      "Eskil": { lat: 38.4000, lng: 33.4167 },
      "Ağaçören": { lat: 38.7333, lng: 34.0500 },
      "Güzelyurt": { lat: 38.2833, lng: 34.3167 },
      "Gülağaç": { lat: 38.2333, lng: 34.2000 },
      "Sarıyahşi": { lat: 38.4000, lng: 33.8167 }
    }
  },
  "Bayburt": {
    lat: 40.2552,
    lng: 40.2249,
    districts: {
      "Merkez": { lat: 40.2552, lng: 40.2249 },
      "Aydıntepe": { lat: 40.4333, lng: 40.1667 },
      "Demirözü": { lat: 40.1333, lng: 39.9667 }
    }
  },
  "Karaman": {
    lat: 37.1759,
    lng: 33.2287,
    districts: {
      "Merkez": { lat: 37.1759, lng: 33.2287 },
      "Ermenek": { lat: 36.6333, lng: 32.9000 },
      "Sarıveliler": { lat: 36.7000, lng: 32.6000 },
      "Kazımkarabekir": { lat: 37.2333, lng: 33.5500 },
      "Ayrancı": { lat: 37.3667, lng: 33.6833 },
      "Başyayla": { lat: 36.6500, lng: 32.5833 }
    }
  },
  "Kırıkkale": {
    lat: 39.8468,
    lng: 33.5153,
    districts: {
      "Merkez": { lat: 39.8468, lng: 33.5153 },
      "Yahşihan": { lat: 39.8500, lng: 33.4500 },
      "Keskin": { lat: 39.6667, lng: 33.6167 },
      "Delice": { lat: 39.9667, lng: 33.8667 },
      "Sulakyurt": { lat: 40.0000, lng: 33.4833 },
      "Bahşılı": { lat: 39.9500, lng: 33.2833 },
      "Balışeyh": { lat: 39.9000, lng: 33.8667 },
      "Çelebi": { lat: 39.5000, lng: 33.8833 },
      "Karakeçili": { lat: 39.5833, lng: 33.4833 }
    }
  },
  "Batman": {
    lat: 37.8812,
    lng: 41.1351,
    districts: {
      "Merkez": { lat: 37.8812, lng: 41.1351 },
      "Kozluk": { lat: 38.1833, lng: 41.4833 },
      "Sason": { lat: 38.3667, lng: 41.3833 },
      "Beşiri": { lat: 37.9000, lng: 41.3000 },
      "Gercüş": { lat: 37.6000, lng: 41.5000 },
      "Hasankeyf": { lat: 37.7167, lng: 41.4000 }
    }
  },
  "Şırnak": {
    lat: 37.5164,
    lng: 42.4611,
    districts: {
      "Merkez": { lat: 37.5164, lng: 42.4611 },
      "Cizre": { lat: 37.3333, lng: 42.2000 },
      "Silopi": { lat: 37.2500, lng: 42.4667 },
      "İdil": { lat: 37.3333, lng: 41.8833 },
      "Uludere": { lat: 37.4333, lng: 42.8500 },
      "Beytüşşebap": { lat: 37.5667, lng: 43.1667 },
      "Güçlükonak": { lat: 37.5000, lng: 42.2333 }
    }
  },
  "Bartın": {
    lat: 41.6344,
    lng: 32.3375,
    districts: {
      "Merkez": { lat: 41.6344, lng: 32.3375 },
      "Ulus": { lat: 41.6000, lng: 32.6500 },
      "Kurucaşile": { lat: 41.8333, lng: 32.7167 },
      "Amasra": { lat: 41.7500, lng: 32.3833 }
    }
  },
  "Ardahan": {
    lat: 41.1105,
    lng: 42.7022,
    districts: {
      "Merkez": { lat: 41.1105, lng: 42.7022 },
      "Göle": { lat: 40.7833, lng: 42.6000 },
      "Çıldır": { lat: 41.1333, lng: 43.1333 },
      "Posof": { lat: 41.5000, lng: 42.7333 },
      "Hanak": { lat: 41.2000, lng: 42.4500 },
      "Damal": { lat: 41.3333, lng: 42.7333 }
    }
  },
  "Iğdır": {
    lat: 39.9167,
    lng: 44.0333,
    districts: {
      "Merkez": { lat: 39.9167, lng: 44.0333 },
      "Tuzluca": { lat: 40.0500, lng: 43.6667 },
      "Aralık": { lat: 39.8667, lng: 44.5167 },
      "Karakoyunlu": { lat: 39.9667, lng: 43.9167 }
    }
  },
  "Yalova": {
    lat: 40.6500,
    lng: 29.2667,
    districts: {
      "Merkez": { lat: 40.6500, lng: 29.2667 },
      "Çiftlikköy": { lat: 40.6667, lng: 29.3167 },
      "Çınarcık": { lat: 40.6333, lng: 29.1167 },
      "Termal": { lat: 40.6167, lng: 29.1667 },
      "Altınova": { lat: 40.6833, lng: 29.5000 },
      "Armutlu": { lat: 40.5167, lng: 28.8333 }
    }
  },
  "Karabük": {
    lat: 41.2061,
    lng: 32.6204,
    districts: {
      "Merkez": { lat: 41.2061, lng: 32.6204 },
      "Safranbolu": { lat: 41.2500, lng: 32.6833 },
      "Yenice": { lat: 41.2000, lng: 32.3333 },
      "Eflani": { lat: 41.4167, lng: 32.9500 },
      "Eskipazar": { lat: 41.0000, lng: 32.5333 },
      "Ovacık": { lat: 41.3333, lng: 32.9167 }
    }
  },
  "Kilis": {
    lat: 36.7184,
    lng: 37.1212,
    districts: {
      "Merkez": { lat: 36.7184, lng: 37.1212 },
      "Musabeyli": { lat: 36.8333, lng: 37.0833 },
      "Elbeyli": { lat: 36.8000, lng: 37.3500 },
      "Polateli": { lat: 36.7833, lng: 37.2500 }
    }
  },
  "Osmaniye": {
    lat: 37.0742,
    lng: 36.2478,
    districts: {
      "Merkez": { lat: 37.0742, lng: 36.2478 },
      "Kadirli": { lat: 37.3667, lng: 36.1000 },
      "Düziçi": { lat: 37.2500, lng: 36.4667 },
      "Bahçe": { lat: 37.2000, lng: 36.5833 },
      "Toprakkale": { lat: 37.0667, lng: 36.1500 },
      "Hasanbeyli": { lat: 37.1333, lng: 36.5500 },
      "Sumbas": { lat: 37.4333, lng: 36.2500 }
    }
  },
  "Düzce": {
    lat: 40.8438,
    lng: 31.1565,
    districts: {
      "Merkez": { lat: 40.8438, lng: 31.1565 },
      "Akçakoca": { lat: 41.0833, lng: 31.1167 },
      "Cumayeri": { lat: 40.8500, lng: 30.9833 },
      "Çilimli": { lat: 40.9167, lng: 31.0333 },
      "Gölyaka": { lat: 40.7833, lng: 31.0167 },
      "Gümüşova": { lat: 40.8500, lng: 30.9167 },
      "Kaynaşlı": { lat: 40.7667, lng: 31.3167 },
      "Yığılca": { lat: 40.9667, lng: 31.4500 }
    }
  }
};

export default turkeyLocations;
